import {
  BLOCKCUSTOMEROPERATIONSLIST_SUCCESS,
  BLOCKCUSTOMEROPERATIONSLIST_FAILED,
  RESET_BLOCKCUSTOMEROPERATIONSLIST,
  LOADING_BLOCKCUSTOMEROPERATIONSLIST,
  NETWORK_ERROR_BLOCKCUSTOMEROPERATIONSLIST,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetBlockCustomerOperationsList = () => {
  return { type: RESET_BLOCKCUSTOMEROPERATIONSLIST };
};

const blockCustomerOperationsList =
  (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_BLOCKCUSTOMEROPERATIONSLIST });
    await partnerServices
      .post("blockCustomerOperations", userData, { headers: { AuthToken: authTokenIs } })
      .then((res) => {
        switch (res.status) {
          case 200:
            dispatch(blockCustomerOperationsListsuccess(res.data));
            break;
          default:
            dispatch(blockCustomerOperationsListFailed(res.data));
            break;
        }
      })
      .catch((err) => {
        dispatch({
          type: NETWORK_ERROR_BLOCKCUSTOMEROPERATIONSLIST,
          payload: err,
        });
      });
  };
function blockCustomerOperationsListsuccess(data) {
  return {
    type: BLOCKCUSTOMEROPERATIONSLIST_SUCCESS,
    payload: data,
  };
}
function blockCustomerOperationsListFailed(data) {
  return {
    type: BLOCKCUSTOMEROPERATIONSLIST_FAILED,
    payload: data,
  };
}

export { resetBlockCustomerOperationsList, blockCustomerOperationsList };
